<template>
  <v-avatar v-if="this.employee.fields['Avatar']" :size="size">
    <img
      :src="imgUrl"
      :alt="employee.fields.Name"
    >
  </v-avatar>
  <v-avatar v-else color="primary" :size="size">
    <span class="white--text" :class="{ headline: showHeadline }">
      {{ initials }}
    </span>
  </v-avatar>
</template>

<script>
  export default {
    name: 'employeeAvatar',
    props: {
      employee: Object,
      size: Number,
      hideHeadline: Boolean
    },
    computed: {
      imgUrl() {
        return this.employee.fields['Avatar'][0].url
      },
      initials () {
        const i = this.employee.fields.Name.match(/\b\w/g) || []
        return ((i.shift() || '') + (i.pop() || '')).toUpperCase()
      },
      showHeadline () {
        return this.hideHeadline ? false : true
      }
    }
  }
</script>
